// Generated by CoffeeScript 1.6.3
/**
 * Common module for all window load functions
 * @class pageLoad
*/

itsoftApp.createModule("pageLoad", function() {
  var $window, events, module, singleFunctionFired, singleLoadFunction, timeoutDelta, timeoutInit;
  module = this;
  events = [];
  $window = itsoftApp.commonVars.$window;
  singleFunctionFired = false;
  timeoutInit = 120;
  timeoutDelta = 80;
  singleLoadFunction = function() {
    var func, readyState, timeoutCurrent, _i, _len;
    readyState = document.readyState;
    if (readyState !== "complete" || singleFunctionFired) {
      return false;
    }
    DEBUG && console.log("[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta);
    for (_i = 0, _len = events.length; _i < _len; _i++) {
      func = events[_i];
      if (typeof func !== "function") {
        continue;
      }
      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }
    singleFunctionFired = true;
  };
  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.on("load ready", singleLoadFunction);
  }
  if (itsoftApp.features.ie === 9) {
    setTimeout(singleLoadFunction, 300);
  }
  module.fire = function() {
    return singleLoadFunction();
  };
  return module.addEvent = function(func) {
    if (typeof func !== "function") {
      return;
    }
    if (!singleFunctionFired) {
      events.push(func);
      return DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length);
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      return func();
    }
  };
});

/*
//@ sourceMappingURL=pageLoad.map
*/
